export function onlyUnique<Type>(value: Type, index: number, ary: Array<Type>) {
  return ary.indexOf(value) === index;
}
